import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {Observable} from 'rxjs/Observable';
import {IRegionListRow} from '../../../_models/vehicle';
import {VehiclesGroupsService} from '../../../_services/vehicles-groups.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {catchError, finalize} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import { PaginationParams } from '../../../_models/generic';

export class MultiSelectRegionsDataSource implements DataSource<IRegionListRow> {

    private vehiclesSubject = new BehaviorSubject<IRegionListRow[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();
    public paginatorTotalCount: number;

    constructor(private vehiclegroupService: VehiclesGroupsService) {

    }

    loadAdminVehicles(params: PaginationParams) {
        this.loadingSubject.next(true);

        this.vehiclegroupService.getMultiselectRegionsList(params).pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe(vehicles => {
                console.log('find regions service dl-multi-select-regions in Datasource: ', vehicles);
                this.paginatorTotalCount = vehicles['count'];
                this.vehiclesSubject.next(vehicles['results']);
            });

    }

    connect(collectionViewer: CollectionViewer): Observable<IRegionListRow[]> {
        console.log("Connecting dl-multi-select-regions data source");
        return this.vehiclesSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.vehiclesSubject.complete();
        this.loadingSubject.complete();
    }

}




// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/dl-multi-select-regions/dl-multi-select-regions.datasource.ts